/**
 * Get the profile image URL based on user type and conversation type
 * @param {Object} params - Parameters
 * @param {Object} params.otherUserInfo - Other user info object
 * @param {boolean} params.isEmployee - Whether current user is an employee
 * @param {boolean} params.isApplicantConversation - Whether this is an applicant conversation
 * @returns {string|null} Profile image URL or null
 */
const getProfileImageUrl = ({ otherUserInfo, isEmployee, isApplicantConversation }) => {
  if (!otherUserInfo) return null;
  
  if (isEmployee) {
    if (isApplicantConversation) {
      return otherUserInfo?.headerData?.imageUrl;
    } else {
      return otherUserInfo?.profileImageUrl;
    }
  } else {
    return otherUserInfo?.profileImageUrl;
  }
};

export default getProfileImageUrl;

